import type { GlobalEventMap } from "@modules/types"

type ExtractDetail<T> = T extends CustomEvent<infer D> ? D : never

export function registerGlobalEventListener<K extends keyof GlobalEventMap>(
    eventName: K,
    callback: (param: GlobalEventMap[K]) => void,
    options: AddEventListenerOptions = {
        passive: true,
    },
) {
    window.addEventListener(eventName, callback as EventListener, options)
}

export function dispatchGlobalEvent<K extends keyof GlobalEventMap>(
    eventName: K,
    detail: ExtractDetail<GlobalEventMap[K]>,
) {
    window.dispatchEvent(
        new CustomEvent(eventName, {
            detail,
        }),
    )
}

export function consumeEvent<T extends Event>(callback: (event: T) => void): (event: T) => void {
    return (event: T): void => {
        event.preventDefault()
        event.stopPropagation()

        callback(event)
    }
}

export function addEventListenerAll<K extends keyof HTMLElementEventMap>(
    elements: Iterable<HTMLElement>,
    type: K,
    listener: (this: HTMLElement, ev: HTMLElementEventMap[K]) => void,
    options?: boolean | AddEventListenerOptions,
): void {
    for (const htmlElement of elements) {
        htmlElement.addEventListener(type, listener, options)
    }
}
